var React = require('react');

function Loader (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"#05D0FF","cx":"250.5","cy":"37.5","r":"37.5","key":0}),React.createElement("circle",{"fill":"#05D0FF","cx":"249.5","cy":"462.5","r":"37.5","key":1}),React.createElement("circle",{"fill":"#FFC400","cx":"462.5","cy":"249.5","r":"37.5","key":2}),React.createElement("circle",{"fill":"#FFC400","cx":"37.5","cy":"249.5","r":"37.5","key":3}),React.createElement("circle",{"fill":"#FF78FF","cx":"92.5","cy":"107.5","r":"37.5","key":4}),React.createElement("circle",{"fill":"#45D400","cx":"92.5","cy":"391.5","r":"37.5","key":5}),React.createElement("circle",{"fill":"#45D400","cx":"407.5","cy":"107.5","r":"37.5","key":6}),React.createElement("circle",{"fill":"#FF78FF","cx":"407.5","cy":"391.5","r":"37.5","key":7})]);
}

Loader.defaultProps = {"viewBox":"0 0 500 500","version":"1.1"};

module.exports = Loader;

Loader.default = Loader;
